import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const routes:Routes=[
    { path: '',component: LoginComponent},
    { path: 'login',component: LoginComponent},
   
]

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule.forChild(routes),
    ],
    declarations: [LoginComponent ]
})

export class LoginModule {
    constructor() {}
 }